module.exports = __webpack_public_path__ + "static/media/zoom-out.1dad04a7.svg";